import GameSequenceInitializerBase from './game_sequence_initializer_base';
import LoginGameStep from '../game_steps/login_gamestep';
import GameSequenceBuilder from '../game_sequence_builder/game_sequence_builder';

export default class HistoryGameSequenceInitializer extends GameSequenceInitializerBase {
    static CLASS = 'HistoryGameSequenceInitializer';

    initSequenceBuilder(): GameSequenceBuilder {
        let gameSequenceBuilder = this._createSequenceBuilder();
        return gameSequenceBuilder.insert(LoginGameStep).last();
    }
}
